import React from "react";
import styled from "styled-components";

const TitleGoBack = styled.div`
  font-family: Gilroy, sans-serif;
  margin-bottom: 16px;

  & .title {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    color: #595959;
  }
`;

const ComponentTitleGoBack = ({ title }) => (
  <TitleGoBack>
    <div className="title">{title}</div>
  </TitleGoBack>
);

export default ComponentTitleGoBack;
